import { render } from "./technicalCharacteristics.vue?vue&type=template&id=5b171d9a&scoped=true"
import script from "./technicalCharacteristics.vue?vue&type=script&lang=js"
export * from "./technicalCharacteristics.vue?vue&type=script&lang=js"

import "./technicalCharacteristics.vue?vue&type=style&index=0&id=5b171d9a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b171d9a"]])

export default __exports__